import React, { useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BonusChecksUI from './BonusChecksUI'
import {
  clearBonusCheck,
  getBonusCheck,
  redeemBonusCheckByReferenceNumber,
} from '../../store/actions/bonus-search-actions'
import { useOnMount } from '../../util/utility-hooks'
import { format } from '../../models/format'

const BonusChecks = props => {
  const [searchButtonClicked, setSearchButtonClicked] = useState(false)
  const [searchCriteria, setSearchCriteria] = useState('')

  useOnMount(() => {
    props.clearBonusCheck()
  })

  const updateSearchCriteria = inputValue => {
    setSearchCriteria(inputValue.replace(/\s/g, ''))
  }

  const useGekasBonusFormat =
    props.representativeId === 'f73d2663-2e06-4343-898a-60f69c3a9ac4'

  const { bonusCheck, searchLoading } = props
  return (
    <BonusChecksUI
      bonusCheck={bonusCheck}
      format={
        useGekasBonusFormat
          ? format.gekasBonusCheckNumber
          : format.bonusCheckNumber
      }
      getBonusCheck={() => {
        setSearchButtonClicked(true)
        props.getBonusCheck(searchCriteria)
      }}
      redeemBonusCheck={() =>
        props.redeemBonusCheckByReferenceNumber(props.bonusCheck.reference)
      }
      searchCriteria={searchCriteria}
      searchButtonClicked={searchButtonClicked}
      searchLoading={searchLoading}
      updateSearchCriteria={updateSearchCriteria}
    />
  )
}

BonusChecks.propTypes = {
  getBonusCheck: PropTypes.func.isRequired,
  clearBonusCheck: PropTypes.func.isRequired,
  redeemBonusCheckByReferenceNumber: PropTypes.func.isRequired,
  bonusCheck: PropTypes.object,
  searchLoading: PropTypes.bool,
}

BonusChecks.defaultProps = {
  bonusCheck: null,
  searchLoading: false,
}

const mapDispatchToProps = dispatch => ({
  getBonusCheck: referenceNumber => {
    dispatch(getBonusCheck(referenceNumber))
  },
  redeemBonusCheckByReferenceNumber: referenceNumber => {
    dispatch(redeemBonusCheckByReferenceNumber(referenceNumber))
  },
  clearBonusCheck: () => {
    dispatch(clearBonusCheck())
  },
})

const mapStateToProps = state => ({
  bonusCheck: state.bonusSearch.bonusCheck,
  searchLoading: state.bonusSearch.searchLoading,
  representativeId: state.storeInfo.currentRepresentative.id,
})

export default connect(mapStateToProps, mapDispatchToProps)(BonusChecks)
